<div class="pwa-updater-section">
  <img [src]="staticImages.logo" alt="لوگو" />
  <h1>آپدیت به آخرین نسخه منتشر شده</h1>
  <h2>
    <span>نسخه: </span>
    <span class="version"> V{{ version }}</span>
  </h2>
  <app-button
    Icon="new_releases"
    Text="تایید"
    Appearance="accent"
    (Click)="submit()"
    [IsButton]="true"
    [FullWidth]="true"
  />
</div>
